import React from "react";
import { useMemo } from "react";
import Chart from "react-google-charts";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ChartLinkWrapper, TitleChart } from "./styled";

const ChartLink = ({ dataTableChart, selected }) => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  const citiesData = useSelector((state) => state.data.citiesData);
  const { t } = useTranslation();

  const cityName = useMemo(() => {
    if (user?.is_superuser === "True" && selected && selected?.code !== -1) {
      return selected?.name;
    }
    return (
      citiesData?.find(
        (element) => element?.code === Number(user?.province_code)
      )?.name || ""
    );
  },[citiesData, selected, user?.is_superuser, user?.province_code]);

  const options = {
    chartArea: { width: "65%", height: "100%" },
    isStacked: true,
    tooltip: { isHtml: true, border: false },
    hAxis: {
      minValue: 0,
    },
    vAxis: {
      textStyle: {
        fontSize: 12, // or the number you want
      },
    },
    colors: ["#CE4A00", "#0089CF", "#CFAC00"],
    bar: { groupWidth: 25 },
  };

  return (
    <ChartLinkWrapper>
      <TitleChart>
        {t("chart.surveyStatistics")} - {cityName}
      </TitleChart>
      <Chart
        chartType="BarChart"
        width="80vw"
        height="600px"
        data={dataTableChart}
        options={options}
      />
    </ChartLinkWrapper>
  );
};

export default ChartLink;
